import { BaseAPIResponse } from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/round-template`;
export const getAllSellableRoundTemplates = async (): Promise<BaseAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/sellable`);
	return response.data;
};
